import "./Home.css"
import { useState, useEffect } from "react"

import HomeCategories from "./HomeCategories"
import HomeHowItWorks from "./HomeHowItWorks"
import HomeContactUs from "./HomeContactUs"
import FeaturedProductList from "./Product/FeaturedList"
import MostFilledProductList from "./Product/MostFilledList"

const Home = () => {
  const [updated] = useState(false)

  useEffect(() => {
    const controller = new AbortController()

    const warmup = async () => {
      try {
        // Optional: warm API / health check
        await fetch(`${process.env.REACT_APP_API_URL}/products?limit=1`, {
          signal: controller.signal,
        })
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("Home warmup failed:", err)
        }
      }
    }

    warmup()

    return () => controller.abort()
  }, [updated])

  return (
    <>
      {/* Header */}
      <header className="masthead pt-1">
        <div className="container-fluid text-dark">
          {/* Dictionary-style definition of the brand */}
          <div className="dictionary-entry mx-auto my-4">
            <h1 className="entry-word">Marafye</h1>
            <p className="entry-pos">verb</p>
            <p className="entry-definition">
              <span className="entry-number">1.</span> The act of combining
              orders to save money.
            </p>
            <p className="entry-example">
              <span className="entry-label">Used in a sentence:</span> “Don’t
              forget to <strong>Marafye</strong> the order — we want to save
              money.”
            </p>
          </div>
          <HomeHowItWorks />
        </div>
      </header>

      {/* Featured */}
      <div className="d-flex justify-content-center">
        <FeaturedProductList updated={updated} />
      </div>

      {/* Most Filled */}
      <div className="d-flex justify-content-center">
        <MostFilledProductList updated={updated} />
      </div>

      {/* Categories */}
      <HomeCategories />

      {/* Contact */}
      <HomeContactUs />
    </>
  )
}

export default Home
